import { render, staticRenderFns } from "./CieloCheckBox.vue?vue&type=template&id=036cd392"
import script from "./CieloCheckBox.vue?vue&type=script&lang=js"
export * from "./CieloCheckBox.vue?vue&type=script&lang=js"
import style0 from "./CieloCheckBox.vue?vue&type=style&index=0&id=036cd392&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports